import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M7.5 3.757H6a2.25 2.25 0 0 0-2.25 2.25v1.5m12.75-3.75H18a2.25 2.25 0 0 1 2.25 2.25v1.5m0 9v1.5a2.25 2.25 0 0 1-2.25 2.25h-1.5m-9 0H6a2.25 2.25 0 0 1-2.25-2.25v-1.5m11.25-4.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
    }, null, -1)
  ])))
}
export default { render: render }